<template>
    <v-card class="elevation-1">
        <v-toolbar flat height="37" @click="statusTodayVisible=!statusTodayVisible">
            <span class="primary--text font-weight-bold">TEAM STATUS TODAY</span>
            <v-spacer></v-spacer>

            <!-- FUTURE UPDATE - Add SignalR push notifications to refresh automatically when members clock-in/out -->
            <v-btn icon @click.stop @click="getTeamStatusToday" title="Refresh" :disabled="loading">
                <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn icon :title="statusTodayVisible ? 'Minimize' : 'Expand'">
                <v-icon>{{ statusTodayVisible ? 'expand_less' : 'expand_more' }}</v-icon>
            </v-btn>
        </v-toolbar>
        <v-data-table
            v-if="statusTodayVisible"
            :headers="header"
            :items="teamStatus"
            :loading="loading"
            :hide-actions="teamStatus.length <= 5"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="paginationSync"
        >
            <template v-slot:items="props">
                <tr @click="$router.push('/myteam/attendance')">

                    <!-- USER -->
                    <td>
                        <v-chip class="user-chip-container">
                            <!-- Avatar (highlight if currently working) -->
                            <v-avatar :color="props.item.clockIn && !props.item.clockOut ? props.item.color : 'transparent'" size="25">
                                <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                            </v-avatar>
                            {{ props.item.firstName }} {{ props.item.lastName }}
                        </v-chip>
                    </td>

                    <!-- STATUS -->
                    <td>
                        <span :class="getStatusMeta(props.item.statusKey).color">
                            {{ props.item.statusForToday }}
                        </span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>

import teamApi from '@/api/team'
import awsS3Helper from '@/helpers/aws-s3'
import { getDefaultTeamId } from '@/helpers/team-selector'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort, getExpandCollapseVisibility, updateExpandCollapseVisibility } from '@/helpers/user-prefs'

export default {     
    name: 'TeamStatusToday',
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            rowsPerPageItems,
            awsS3Helper,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            header: [
                {text:'Employee', align:'left', value:'lastName', sortable:true},
                {text:'Status', align: 'left', value:'statusForToday', sortable:true},
            ],
            statusTodayVisible: getExpandCollapseVisibility(routeName, 'team-status-today'),
            error: false,
            errorMessage: '',
            loading: false,
            selectedTeamId: null,

            //static data - transfer to constants
            status_today_types: {
                WORKING: {
                    color: 'green--text',
                    icon: 'mdi-briefcase-clock'
                },
                OVERTIME: {
                    color: 'deep-orange--text',
                    icon: 'mdi-timer-alert'
                },
                LATE: {
                    color: 'orange--text',
                    icon: 'mdi-clock-alert'
                },
                ABSENT: {
                    color: 'red--text',
                    icon: 'mdi-account-off'
                },
                LOGGED_OFF: {
                    color: 'grey--text',
                    icon: 'mdi-logout'
                },
                ON_LEAVE: {
                    color: 'blue--text',
                    icon: 'mdi-beach'
                },
                NOT_STARTED: {
                    color: '',
                    icon: 'mdi-clock-outline'
                },
                UNKNOWN: {
                    color: '',
                    icon: 'mdi-help-circle-outline'
                }
            },
            teamStatus: []
        }
    },
    methods: {
        getStatusMeta(statusKey) {
            return this.status_today_types[statusKey] || status_today_types.UNKNOWN
        },
        async getTeamStatusToday() {
            try {
                this.loading = true
                this.selectedTeamId = await getDefaultTeamId()
                const response = await teamApi.getTodaysStatusByTeam(this.selectedTeamId)
                if (response && response.status == 200) {
                    this.teamStatus = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    async created() {
        this.getTeamStatusToday()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        statusTodayVisible(newVal) {
            updateExpandCollapseVisibility(this.$route.name, 'team-status-today', newVal)
        },
    },
}
</script>